<template>
  <v-main
    id="main"
    v-if="payments && tenant"
    class="fill-height fill-width"
    >
    <v-container
      class="ml-n2 pa-0 d-flex justify-center"
      fluid
      >
      <v-card
        id="card"
        class="white"
        flat
        tile
        min-height="29cm"
        width="22cm"
        >
        <v-card-title
          class="white fill-width pb-0 justify-center"
          >
          {{ tenant.profile.name }}
        </v-card-title>

        <v-card-text
          class="white fill-height fill-width"
          >
          <v-row
            class="d-flex flex-row align-center"
            >
            <v-col
              class="pt-0"
              cols="7">
              <div
                class="text-h6"
                >
                {{ currentUser.selectedAgency.name }}
              </div>
              <div
                class="text-subtitle-2"
                >
                {{ currentUser.selectedAgency.address }}
                <br/>
                {{ currentUser.selectedAgency.website }}
                <br/>
                {{ currentUser.selectedAgency.email }}
                <br/>
                3482-481147
                <br/>
                3482-439252
              </div>
            </v-col>

            <v-col
              cols="2"
              class="pt-0 text-center"
              >
              <div
                class="text-h6"
                >
                {{ receipt.number }}
              </div>
              <div>
                Rendición N°
              </div>
              <div
                class="caption"
                >
                Documento no válido como factura
              </div>
            </v-col>

            <v-col
              cols="3"
              class="pt-0 text-center"
              >
              <img
                class="fill-width"
                :src="require('@/assets/logo.jpeg')"
                ></img>
            </v-col>
          </v-row>

          <v-row>
            <v-col 
              cols="7" 
              class="pt-0 d-flex flex-row justify-space-between"
              >
              <span class="font-weight-bold">Fecha de pago:</span>
              <span>{{ (new Date(receipt.createdAt)).toLocaleDateString() }}</span>
            </v-col>

            <v-col
              cols="12"
              class="py-0 blue--text font-weight-medium"
              >
              Cliente (locador)
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              >
              {{ tenant.profile.name }}
            </v-col>
            
            <v-col
              cols="12"
              class="py-0"
              >
              DNI {{ tenant.profile.dni }}
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              >
              {{ tenant.profile.address }}
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-simple-table
                dense
                >
                <template v-slot:default>
                  <thead
                    class="primary">
                    <tr>
                      <th class="text-left white--text">
                        Descripción
                      </th>
                      <th>
                      </th>
                      <th class="text-center white--text">
                        Período
                      </th>
                      <th class="text-right white--text">
                        Ingreso
                      </th>
                      <th class="text-right white--text">
                        Egreso
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="primary white--text lighten-2"
                      >
                      <td>
                        Alquileres
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr
                      @click="openModal(payment)"
                      style="cursor: pointer"
                      v-for="payment in rentIncome"
                      :key="payment.id"
                      >
                      <td>{{ fullAddress(payment.contract.property) }}</td>
                      <td
                        class="text-right"
                        >{{ payment.isAdvanced ? 'Adelantado' : '' }}</td>
                      <td
                        class="text-center"
                        >
                        {{ (new Date(payment.dueDate)).toLocaleString('default', { month: 'long' }) }}
                      </td>
                      <td
                        class="text-right"
                        >
                        {{ price(Math.abs(payment.partialAmount), payment.currency) }}
                      </td>
                      <td></td>
                    </tr>

                    <tr
                      v-if="!!rentOutcome"
                      >
                      <td>Comisión</td>
                      <td
                        class="text-right"
                        ></td>
                      <td
                        class="text-center"
                        ></td>
                      <td></td>
                      <td
                        class="text-right"
                        >
                        <div
                          class="text-right"
                          >
                          <div
                            v-for="payment in Object.entries(rentOutcome)"
                            v-if="payment[1]"
                            >
                            {{ price(payment[1], payment[0]) }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr
                      v-if="chargebacks"
                      >
                      <td>
                        Intereses
                      </td>
                      <td>
                      </td>
                      <td
                        class="text-center"
                        >{{ (new Date()).toLocaleString('default', { month: 'long' }) }}</td>
                      </td>
                      <td
                        class="text-right">
                        {{ price(Math.abs(dueChargebacks)) }}
                      </td>
                      <td
                        class="text-right"
                        >
                        {{ price(Math.abs(ownChargebacks)) }}
                      </td>
                    </tr>

                    <tr
                      class="primary white--text lighten-2"
                      >
                      <td>
                        Impuestos / Servicios
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr
                      v-for="payment in servicesIncome"
                      @click="openModal(payment)"
                      style="cursor: pointer"
                      >
                      <td>
                        {{ payment.payableName || payment.concept }}
                      </td>
                      <td>
                      </td>
                      <td
                        class="text-center"
                        >
                        {{ (new Date(payment.dueDate)).toLocaleString('default', { month: 'long' }) }}
                      </td>
                      </td>
                      <td
                        class="text-right">
                        {{ price(Math.abs(payment.partialAmount), payment.currency) }}
                      </td>
                      <td>
                      </td>
                    </tr>

                    <tr
                      v-for="payment in servicesOutcome"
                      @click="openModal(payment)"
                      style="cursor: pointer"
                      >
                      <td>
                        {{ payment.payableName || payment.concept }}
                      </td>
                      <td>
                      </td>
                      <td
                        class="text-center"
                        >
                        {{ (new Date(payment.dueDate)).toLocaleString('default', { month: 'long' }) }}
                      </td>
                      <td>
                      </td>
                      <td
                        class="text-right">
                        {{ price(Math.abs(payment.partialAmount), payment.currency) }}
                      </td>
                    </tr>

                    <tr
                      class="primary white--text lighten-2"
                      >
                      <td>
                        Otros
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr
                      v-for="payment in othersOutcome"
                      @click="openModal(payment)"
                      style="cursor: pointer"
                      >
                      <td>
                        {{ payment.payableName || payment.concept }}
                      </td>
                      <td>
                      </td>
                      <td
                        class="text-center"
                        >{{ (new Date()).toLocaleString('default', { month: 'long' }) }}</td>
                      </td>
                      <td>
                      </td>
                      <td
                        class="text-right">
                        {{ price(Math.abs(payment.partialAmount), payment.currency) }}
                      </td>
                    </tr>

                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td
                        class="text-center font-weight-medium"
                        >
                        Total
                      </td>
                      <td
                        class="text-right"
                        >
                        <div
                          class="text-right"
                          >
                          <div
                            v-for="payment in Object.entries(total)"
                            v-if="payment[1]"
                            >
                            {{ price(payment[1], payment[0]) }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <template
                      v-for="payment in receipt.paymentTypes"
                      >
                      <tr
                        >
                        <td></td>
                        <td></td>
                        <td></td>
                        <td
                          class="text-center font-weight-medium blue--text"
                          >
                          {{ payment.name }}
                        </td>

                        <td
                          class="text-right"
                          width="100"
                          :key="payment.amount"
                          >
                          {{ price(Math.abs(payment.amount), payment.currency) }}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>

            <v-col
              cols="12"
              class="text-right"
              v-if="!printing"
              >
              <create-payment-types
                :id="receipt.id"
                :paymentTypes="receipt.paymentTypes"
                @reload="fetchPayments"
                ></create-payment-types>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="font-weight-medium"
              >
              Firma
            </v-col>
          </v-row>

          <v-divider></v-divider>
        </v-card-text>
      </v-card>

      <v-btn
        fab
        fixed
        bottom
        right
        color="primary"
        class="rounded-circle d-print-none"
        @click="print"
        >
        <v-icon>
          mdi-printer
        </v-icon>
      </v-btn>

    </v-container>
  </v-main>
</template>

<script>
import { Print } from '@/graphql/mutations/receipts' 
import { Receipt } from '@/graphql/queries/receipt' 
import { Contact } from '@/graphql/queries/directory'
import { mapGetters } from 'vuex'
import html2pdf from 'html2pdf.js'
import $ from 'jquery'

import CreatePaymentTypes from '@/components/payments/receipts/CreatePaymentTypes'

export default {
  data () {
    return {
      receipt: null,
      tenant: null,
      payments: null,
      printing: false,
      selected: null,
      modal: false,
      total: {
        "ARS": 0,
        "USD": 0
      },
      paymentMethods: [
        {
          method: 'Efectivo',
          currency: "ARS",
          amount: null
        }
      ]
    }
  },

  mounted () {
    this.fetchTenant()
    this.fetchPayments()
  },

  computed: {
    ...mapGetters(['currentUser']),

    contract () {
      return this.tenant.activeContracts[0]
    },

    rentIncome () {
      return this.allPayments.filter( v => ['Alquiler'].includes(v.concept) && (!(v.referralId == this.$route.params.user_id && v.referralType == 'User')))
    },

    rentOutcome () {
      var outcome = {
        "ARS": 0,
        "USD": 0
      }
      var total = this.allPayments.filter( v => (['Honorarios'].includes(v.concept) || (v.concept == 'Alquiler' && v.referralId == this.$route.params.user_id && v.referralType == 'User')) )
      
      total.forEach( payment => {
        outcome[payment.currency] += payment.lastingAmount
      })

      return outcome
    },

    servicesIncome () {
      var arr = this.allPayments.filter( v => {
        var band = (v.receiverType == 'User' && v.receiverId == this.$route.params.user_id) && !(['Alquiler'].includes(v.concept))
        return band
      })

      var helper = {};
      var result = arr.reduce(function(r, o) {
        var key = o.concept + '-' + (new Date(o.dueDate)).toLocaleString('default', { month: 'long' });

        if(!helper[key]) {
          helper[key] = Object.assign({}, o); // create a copy of o
          r.push(helper[key]);
        } else {
          helper[key].partialAmount += o.partialAmount;
        }

        return r;
      }, []);

      return result
    },

    servicesOutcome () {
      var arr = this.allPayments.filter( 
        v => {
          var band = !['Alquiler', 'Honorarios', 'Reparaciones'].includes(v.concept) 
          var band2 = !(v.receiverType == 'User' && v.receiverId == this.$route.params.user_id)
          return (band && band2)
        }
      )

      var helper = {};
      var result = arr.reduce(function(r, o) {
        var key = o.concept + '-' + (new Date(o.dueDate)).toLocaleString('default', { month: 'long' });

        if(!helper[key]) {
          helper[key] = Object.assign({}, o); // create a copy of o
          r.push(helper[key]);
        } else {
          helper[key].partialAmount += o.partialAmount;
        }

        return r;
      }, []);

      return result
    },

    othersOutcome () {
      return this.allPayments.filter( v => ['Reparaciones'].includes(v.concept) )
    },

    paid () {
      return this.allPayments.filter( v => v.state == 'paid').reduce((a, b) => a + (b['partialAmount'] || 0), 0)
    },

    dueChargebacks () {
      let amount = 0

      this.allPayments.filter( v => !(v.referralType == 'User' && v.referralId == this.$route.params.user_id)).forEach(p => {
        p.chargebacks.forEach( c => {
          if (c.active) {
            amount += c.amount
          }
        })
      })

      return amount
    },

    ownChargebacks () {
      let amount = 0

      this.allPayments.filter( v => v.referralType == 'User' && v.referralId == this.$route.params.user_id ).forEach(p => {
        p.chargebacks.forEach( c => {
          if (c.active) {
            amount += c.amount
          }
        })
      })

      return amount
    },

    chargebacks () {
      return this.ownChargebacks || this.dueChargebacks
    },

    allPayments () {
      return this.payments
    }
  },

  methods: {
    fetchPayments () {
      this.$apollo.query({
        query: Receipt,
        variables: {
          id: this.$route.params.id
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        this.receipt = res.data.receipt
        this.payments = res.data.receipt.payments

        this.total = {
          "USD": 0,
          "ARS": 0
        }

        this.payments.forEach ( payment => {
          this.total[payment.currency] += payment.lastingAmount
        })

        this.$forceUpdate()
      })
    },

    fetchTenant (policy = 'cache-first') {
      this.$apollo.query({
        query: Contact,
        variables: {
          contactId: this.$route.params.user_id
        },
        fetchPolicy: policy
      }).then(res => {
        this.tenant = res.data.contact
      })
    },

    print () {
      this.printing = true
      this.$apollo.mutate({
        mutation: Print,
        variables: {
          input: {
            id: this.$route.params.id
          }
        }
      }).then( res => {
        var element = document.body;
        html2pdf(element, {
          margin: 0,
          filename: 'document.pdf',
          image: { type: 'jpg', quality: 0.98 },
          html2canvas: { dpi: 192, letterRendering: true, useCORS: true },
          jsPDF: { unit: 'cm', format: 'a4', orientation: 'portrait' }
        })
        this.printing = false
      })
    },

    fullAddress (property) {
      let address = property.address
      return address.street + ' ' + address.number + ' ' + (address.unit || '') + ', ' + address.city + ', ' + address.state
    },

    imageUrl (url) {
      return process.env.VUE_APP_RAILS_URL + url
    },
    
    removeMethod (idx) {
      this.paymentMethods.splice(idx, 1)
    },

    price (price, currency = "ARS") {
      var formatter = new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: currency,

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });

      return formatter.format(Math.abs(price)); /* $2,500.00 */
    },

    openModal (payment) {
      this.selected = payment
      this.modal = true
    },

    reload () {
      this.fetchPayments ()
    }
  },

  components: {
    CreatePaymentTypes
  }
}
</script>
